// Copied list from Gudrid
export const GUDRID_SESSION_EVENTS = {
    BUNDLE_COMMANDS: 'bundle_commands',
    SET_EYELID_POSITION: 'set_eyelid_position',
    SET_IRIS_MODE: 'set_iris_mode',
    SET_IRIS_SIZE: 'set_iris_size',
    CHECK_PULSE: 'check_pulse',
    SET_PULSE_RATE: 'set_pulse_rate',
    SET_PULSE_STRENGTH: 'set_pulse_strength',
    SET_LUNG_COMPLIANCE: 'set_lung_compliance',
    SET_LUNG_RESISTANCE: 'set_lung_resistance',
    SET_LUNG_STOMACH_DISTENTION: 'set_lung_stomach_distention',
    SET_LUNG_EXHALE_CO2: 'set_lung_exhale_co2',
    SET_LUNG_TONGUE_FALLBACK: 'set_lung_tongue_fallback',
    SET_LUNG_TONGUE_EDEMA: 'set_lung_tongue_edema',
    SET_LUNG_FBAO: 'set_lung_fbao',
    SET_LUNG_TRISMUS: 'set_lung_trismus',
    SET_LUNG_PHARYNGEAL_OBSTRUCTION: 'set_lung_pharyngeal_obstruction',
    SET_LUNG_DECREASED_CERVICAL_RANGE_OF_MOTION: 'set_lung_decreased_cervical_range_of_motion',
    SET_LUNG_LARYNGOSPASM: 'set_lung_laryngospasm',
    SET_LUNG_TENSION_PNEUMOTHORAX: 'set_lung_tension_pneumothorax',
    SET_LUNG_PRESET: 'set_lung_preset',
    SET_LUNG_BREATHE_ONCE: 'set_lung_breathe_once',
    SET_SPO2: 'set_spo2',
    SET_ETCO2: 'set_etco2',
    SET_BP: 'set_bp',
    SET_TPERI: 'set_tperi',
    SET_BPM: 'set_bpm',
    SET_RR: 'set_rr',
    SET_HEART_SOUND: 'set_heart_sound',
    SET_LUNG_SOUND: 'set_lung_sound',
    HEART_RATE_CHANGE: 'heart_rate_change',
    SPO2_CHANGE: 'spo2_change',
    ETCO2_CHANGE: 'etco2_change',
    SYSTOLIC_CHANGE: 'systolic_change',
    DIASTOLIC_CHANGE: 'diastolic_change',
    TPERI_CHANGE: 'tperi_change',
    RESPIRATORY_RATE_CHANGE: 'respiratory_rate_change',
    SET_INITIAL_VITALS: 'set_initial_vitals',
    CPR_COMPRESSION: 'cpr_compression',
    BREATHING_LUNG_VOLUME: 'breathing_lung_volume',
} as const;

export const GUDRID_SESSION_EVENT_TRIGGERED_BY = {
    INSTRUCTOR_APP: 'instructor_app',
    MANIKIN: 'manikin',
    AUTOMATIC_TRANSITION: 'automatic_transition',
} as const;

export type GudridSessionEventTriggeredByType =
    (typeof GUDRID_SESSION_EVENT_TRIGGERED_BY)[keyof typeof GUDRID_SESSION_EVENT_TRIGGERED_BY];

export type BundleCommandsParameters = {
    vitals: Record<string, unknown>;
    controls: Record<string, unknown>;
    transitionDurationSeconds?: number;
};
